import { auth } from '../../services/auth.js'
import { AuthSplitLayout } from '../../layouts/AuthSplitLayout.js'
import { AuthHero } from '../../components/AuthHero.js'
import { LoginForm } from '../../components/LoginForm.js'
import { pickAuthPhrase } from '../../services/auth-phrases.js'

export const Login = {
  async render() {
    if (auth.isAuthenticated()) {
      window.location.href = '/pages/launcher.html'
      return
    }

    const hero = AuthHero(pickAuthPhrase())
    const form = LoginForm()

    const root = document.querySelector('#app-root')
    root.innerHTML = AuthSplitLayout({ hero, form })

    this.attachListeners()
  },

  attachListeners() {
    const form = document.querySelector('#login-form')
    const button = document.querySelector('#login-button')
    const errorDiv = document.querySelector('#error-message')

    // "Mantener sesión" también recuerda el email: si en una visita previa el
    // usuario marcó el checkbox, precargamos su correo y dejamos el checkbox
    // marcado, enfocando directo la contraseña. Nunca guardamos la contraseña.
    const REMEMBER_EMAIL_KEY = 'login:remember_email'
    try {
      const savedEmail = localStorage.getItem(REMEMBER_EMAIL_KEY)
      if (savedEmail) {
        document.querySelector('#email').value = savedEmail
        const remember = document.querySelector('#remember-me')
        if (remember) remember.checked = true
        document.querySelector('#password')?.focus()
      }
    } catch (_) {
      /* localStorage no disponible (modo privado / bloqueado) — sin precarga */
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault()

      const email = document.querySelector('#email').value
      const password = document.querySelector('#password').value

      try {
        button.disabled = true
        document.querySelector('#button-text').textContent = 'Entrando...'
        document.querySelector('#login-icon')?.classList.add('hidden')
        const spinner = document.querySelector('#loading-spinner')
        spinner.classList.remove('hidden')
        spinner.classList.add('animate-spin')
        errorDiv.classList.add('hidden')

        const remember = document.querySelector('#remember-me')?.checked ?? false
        // Persistimos (o limpiamos) el email recordado según el checkbox, antes
        // de la llamada: si el login falla, el correo sigue precargado al reintentar.
        try {
          if (remember) localStorage.setItem(REMEMBER_EMAIL_KEY, email)
          else localStorage.removeItem(REMEMBER_EMAIL_KEY)
        } catch (_) {
          /* localStorage no disponible — el login continúa igual */
        }
        const response = await auth.login(email, password, { persistent: remember })

        // Inc 9 (2FA): si el Hub pide segundo factor, el login devuelve un
        // challenge (requires_2fa + partial_token) sin sesión. Guardamos el
        // partial_token en sessionStorage (vida corta, scope de pestaña) y
        // vamos a la pantalla del código. Ver pages/verify-2fa.
        if (response?.requires_2fa) {
          sessionStorage.setItem('mfa_partial_token', response.partial_token || '')
          sessionStorage.setItem('mfa_persistent', remember ? '1' : '0')
          window.location.href = '/pages/verify-2fa.html'
          return
        }

        if (response?.user?.must_change_password) {
          window.location.href = '/pages/change-password.html'
        } else {
          window.location.href = '/pages/launcher.html'
        }
      } catch (error) {
        button.disabled = false
        document.querySelector('#button-text').textContent = 'Entrar'
        const spinner = document.querySelector('#loading-spinner')
        spinner.classList.add('hidden')
        spinner.classList.remove('animate-spin')
        document.querySelector('#login-icon')?.classList.remove('hidden')

        const detail = error.response?.data?.detail
        const messages = {
          'auth.invalid_credentials': 'Usuario o contraseña incorrectos.',
          'auth.user_locked': 'Cuenta bloqueada por intentos fallidos. Contacta a un administrador.',
          'auth.user_inactive': 'Tu cuenta no está activa.',
          'auth.user_pending': 'Tu cuenta aún no ha sido activada.',
        }
        const errorMsg = messages[detail] || detail || error.message || 'Error desconocido'
        document.querySelector('#error-text').textContent = errorMsg
        errorDiv.classList.remove('hidden')
      }
    })
  }
}
